import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { ConfigProvider } from './contexts/ConfigContext'
import { MsalWrapper } from './components/MsalWrapper'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'

// Create the router
const router = createRouter({ routeTree })

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }

  // Extend router context to include security context
  interface RouterContext {
    security?: import('./security/routeSecurityVerifier').GlobalContext
  }
}

export default function App() {
  return (
    <ConfigProvider>
      <MsalWrapper>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ToastProvider>
      </MsalWrapper>
    </ConfigProvider>
  )
}
